var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0216 3.15259C9.43581 3.15259 6.52164 6.06675 6.52164 9.65259V12.7834C6.52164 13.4443 6.23997 14.4518 5.90414 15.0151L4.65831 17.0843C3.88914 18.3626 4.41997 19.7818 5.82831 20.2584C10.4975 21.8184 15.535 21.8184 20.2041 20.2584C21.515 19.8251 22.0891 18.2759 21.3741 17.0843L20.1283 15.0151C19.8033 14.4518 19.5216 13.4443 19.5216 12.7834V9.65259C19.5216 6.07759 16.5966 3.15259 13.0216 3.15259Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0258 3.46656C13.7157 3.09345 12.3275 3.09345 11.0175 3.46656C11.3316 2.6649 12.1116 2.10156 13.0216 2.10156C13.9316 2.10156 14.7116 2.6649 15.0258 3.46656V3.46656Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2716 20.6484C16.2716 22.4359 14.8091 23.8984 13.0216 23.8984C12.1333 23.8984 11.3099 23.5301 10.7249 22.9451C10.1163 22.3355 9.77355 21.5099 9.77161 20.6484",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.9b66bec8b153a5d5f2a069ef28e87a10.svg";
export { ForwardRef as ReactComponent };